import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-055c6efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }

import { ref, onMounted } from 'vue'
import { queryDdviceDeliveryPage } from '@/api'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import { useRoute } from 'vue-router'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'record-table',
  setup(__props) {

const $route = useRoute()

const deviceId = $route.query.deviceId || ''

const tableData = ref([])
const tableLoading = ref(false)

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryDdviceDeliveryPage({
    ...pageParams.value,
    deviceId,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const tableColumn: any = [
  {
    prop: 'operateName',
    label: '操作类型',
  },
  {
    prop: 'operateTime',
    label: '时间',
    formatter: ({ operateTime }: any) => {
      return moment(operateTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'topOrgName',
    label: '所属租户',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      class: "ws_common_table ws_mt24"
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, { description: "暂无数据" })
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableColumn, (item, index) => {
          return _createVNode(_component_el_table_column, {
            key: index,
            prop: item.prop,
            label: item.label,
            formatter: item.formatter
          }, null, 8, ["prop", "label", "formatter"])
        }), 64))
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      class: "ws_mt50",
      "current-page": pageParams.value.curPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
      "page-size": pageParams.value.pageSize,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
      "page-sizes": _unref(PAGE_SIZES),
      layout: "->, total, sizes, prev, pager, next, jumper ",
      total: total.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
  ]))
}
}

})